import React from "react";

function NoPage() {
  return (
    <>
      <h2>this is No Page</h2>
      <p></p>
    </>
  );
}
export default NoPage;
